var map = {
	"./arrowdown.js": 5820,
	"./arrowleft.js": 667,
	"./arrowright.js": 5407,
	"./arrowup.js": 3089,
	"./bgcut.js": 1506,
	"./blackhole.js": 4553,
	"./blanksquare.js": 6406,
	"./fillrect.js": 1042,
	"./maintitle.js": 9555,
	"./neutronstar.js": 8251,
	"./progress.js": 9938,
	"./text.js": 8928,
	"./tunnel.js": 5907,
	"./xsquare.js": 9355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4837;